import React, { ComponentProps, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { routerPath } from 'src/app/router/ui/AppRouter';
import { ServiceCard } from 'src/entities/ServiceCard';
import GlobalSVG from 'src/shared/assets/svg/illustrations/undraw_around_the_world_re_rb1p.svg';
import GoldSvg from 'src/shared/assets/svg/illustrations/undraw_data_trends_re_2cdy.svg';
import HomeSVG from 'src/shared/assets/svg/illustrations/undraw_sweet_home_dkhr.svg';
import { Modal } from 'src/shared/ui/Modal/Modal';
import { CertificatesMC } from 'src/widgets/CertificatesMC';
import s from './ServicesList.module.scss';
import { AIInsightsMC } from 'src/widgets/AIInsightsMC/ui/AIInsightsMC/AIInsightsMC';

export const ServicesList: React.FC = () => {
	const navigate = useNavigate();

	// * Selector
	const [certificatesModal, setCertificatesModal] = useState(false);
	const openCertificatesModal = () => setCertificatesModal(true);
	const closeCertificatesModal = () => setCertificatesModal(false);

	const [AIInsightsModal, setAIInsightsModal] = useState(false);
	const openAIInsightsModal = () => setAIInsightsModal(true);
	const closeAIInsightsModal = () => setAIInsightsModal(false);

	const serviceCards: ComponentProps<typeof ServiceCard>[] = [
		{
			Title: 'Get company certificate',
			Description:
				'Showcase your commitment to diversity with the certification provided by Denominator. Leverage your diversity scores in procurement to earn recognition for your organization’s performance.',
			SVG: <HomeSVG />,
			cta: {
				text: 'Download',
				onClick: () => openCertificatesModal(),
			},
		},
		{
			Title: 'See company report',
			Description: 'Interested in knowing your company’s diversity performance compared to peers? See the report to identify potential gaps and opportunities',
			SVG: <GlobalSVG />,
			cta: {
				text: 'View it',
				onClick: () => navigate(routerPath.reportPage),
			},
		},
		{
			Title: (
				<>
					Denominator<sup>AI Insights</sup>
				</>
			),
			Description: 'Explore how your company can improve it’s diversity performance via simple guides to strengthening  current practices.',
			SVG: <GoldSvg />,
			cta: {
				text: 'Explore',
				onClick: () => openAIInsightsModal(),
			},
		},
	];

	// * Render
	return (
		<>
			<Modal
				isOpen={certificatesModal}
				onClose={closeCertificatesModal}
			>
				<CertificatesMC />
			</Modal>

			<Modal
				isOpen={AIInsightsModal}
				onClose={closeAIInsightsModal}
			>
				{AIInsightsModal && <AIInsightsMC />}
			</Modal>

			<div className={s.cardsList}>
				{serviceCards.map((service, index) => (
					<ServiceCard
						data-test={'service_card_' + index.toString()}
						key={index}
						{...service}
					/>
				))}
			</div>
		</>
	);
};
